import { render, staticRenderFns } from "./Fixed-Header.vue?vue&type=template&id=24556856&scoped=true&"
import script from "./Fixed-Header.vue?vue&type=script&lang=js&"
export * from "./Fixed-Header.vue?vue&type=script&lang=js&"
import style0 from "./Fixed-Header.vue?vue&type=style&index=0&id=24556856&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24556856",
  null
  
)

export default component.exports